module.exports = __webpack_public_path__ + "img/cid-B.8c7f317a.svg";